import { render } from "./ManageClientSidenav.vue?vue&type=template&id=4c7f1b83"
import script from "./ManageClientSidenav.vue?vue&type=script&lang=js"
export * from "./ManageClientSidenav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__